import React from "react";
import BreadCrumb from "components/common/BreadCrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { getDocumentTitle } from "utils/helpers";
import { PayslipsTable } from "./PayslipsTable";

const PayslipList = () => {
  document.title = getDocumentTitle("Payslips");

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Payslips" pageTitle="Finance" />
        <Card>
          <CardHeader>
            <h5 className="card-title mb-0">Payslips</h5>
          </CardHeader>
          <CardBody>
            <PayslipsTable />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PayslipList;
